import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { useFetch } from "@chainless/chainless-react";
import "./ImagePopup.css";
import { FaImage } from "react-icons/fa";

export const ImagePopup = ({ src }) => {
  const { data } = useFetch(src);
  const [visible, setVisible] = useState(false);

  if (!src) return null;

  return (
    <div className="image-popup">
      {data && data.image && (
        <>
          <FaImage className="image-popup-thumbnail" onClick={() => setVisible(true)} />
          <Dialog
            visible={visible}
            style={{ width: "auto", maxWidth: "90vw" }}
            contentClassName="image-popup-dialog-content"
            onHide={() => setVisible(false)}
            dismissableMask
            closable
            modal
          >
            <img
              alt={data.alt}
              src={data.image}
              className="image-popup-dialog-img"
            />
          </Dialog>
        </>
      )}
    </div>
  );
};
